<div class="title">{{node?.entity?.title}}</div>
<!--{{entity.title}}-->
